import { Head, CleanContent } from './ui';
import { meanings } from '../data';

export default function StarMeanings() {
  return (
    <CleanContent><section className="py-5">
        <div className="container">
          <Head eyebrow="The Meaning Behind The Rank" title="What Does Each Star Mean"
            text="Each Star milestone acts as an unambiguous market credential indicating precise operational readiness and trust caliber" />
          <div className="row g-3">
            {meanings.map(([n, t, d]) => (
              <div className="col-md-6" key={n}>
                <div className={`border border-line rounded-3 p-3 h-100 d-flex gap-3 ${n === "10" ? "tier-gold" : ""}`}>
                  <span className="tier-star text-nowrap">{n}<i className="bi bi-star-fill ms-1" /></span>
                  <div><div className="h-md">{t}</div><p className="p-sm mb-0">{d}</p></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section></CleanContent>
  );
}
